<figure
  [class.custom-size]="hasCustomSize"
  [style.--icon-width]="customWidthValue"
  [style.--icon-height]="customHeightValue"
  class="{{ figurenone ? 'nofigure' : '' }} {{
    isButtonIcon ? 'button-icon' : ''
  }} {{ center ? 'center' : '' }}">
  <div class="tooltiptext tooltiptext--info-level" *ngIf="showTooltip">
    <span id="label-tooltip"
      >Los puntos no son acumulables para el siguiente nivel</span
    >
  </div>
  <img
    [class.active]="iconActive"
    [class.custom-size]="hasCustomSize"
    src="{{ url }}"
    alt="Icon - {{ icon }}"
    class="{{ style }}" />
</figure>
